/** The NHL Coins edition a card reads when its page names none. */
export const NHL_COINS_EDITION_ID = 'nhl-coins-2026';
